// extracted by mini-css-extract-plugin
export default {"otpStatus":"OtpStatus_otpStatus__9LTCH","spinner":"OtpStatus_spinner__1qZsE","message":"OtpStatus_message__DJkXx","error":"OtpStatus_error__tutSm"};